const ROOT_FIELDS = [
  "business",
  "navigation",
  "hero",
  "catalog",
  "about",
  "highlightsIntro",
  "highlights",
  "contact",
  "footer",
  "messages",
  "notifications",
  "appearance",
  "theme",
  "designTokens",
  "seo",
  "sections",
  "layout",
];

function clone(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

const THEME_TO_DESIGN_TOKEN_COLORS = Object.freeze({
  primaryColor: "primary",
  secondaryColor: "secondary",
  surfaceColor: "surface",
  backgroundColor: "background",
  textColor: "text",
  mutedTextColor: "mutedText",
  dividerColor: "divider",
});

function synchronizeGlobalColors(payload) {
  if (!payload?.theme || !payload?.designTokens) return payload;
  const colors = { ...(payload.designTokens.colors || {}) };
  Object.entries(THEME_TO_DESIGN_TOKEN_COLORS).forEach(([themeKey, tokenKey]) => {
    const value = payload.theme?.[themeKey];
    if (value !== undefined && value !== null && String(value).trim()) {
      colors[tokenKey] = value;
    }
  });
  payload.designTokens = { ...payload.designTokens, colors };
  return payload;
}

export function settingsPayload(form = {}, productsEnabled = true) {
  const payload = { schemaVersion: 12 };

  ROOT_FIELDS.forEach((field) => {
    if (form[field] !== undefined) payload[field] = clone(form[field]);
  });

  if (!productsEnabled) {
    payload.navigation = {
      ...(payload.navigation || {}),
      showProductsLink: false,
      showCart: false,
    };
    payload.sections = {
      ...(payload.sections || {}),
      showProducts: false,
      showFeatured: false,
      showCategories: false,
      showBrands: false,
      showSpotlight: false,
    };
  }

  return synchronizeGlobalColors(payload);
}
